import React from 'react';
import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// date-fns v3 requires the V3 adapter module path; the default
// @mui/x-date-pickers/AdapterDateFns targets v2 and fails to resolve
// date-fns/_lib/format/longFormatters under v3. The exported class is still
// named AdapterDateFns - only the import path differs.
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';

interface DateRangePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  startLabel?: string;
  endLabel?: string;
  disabled?: boolean;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  startLabel = 'Start Date',
  endLabel = 'End Date',
  disabled = false,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ display: 'contents' }}>
        <DatePicker
          label={startLabel}
          value={startDate}
          onChange={onStartDateChange}
          disabled={disabled}
          maxDate={endDate || undefined}
          slotProps={{
            textField: {
              size: 'small',
              sx: { minWidth: 150, flex: { xs: '1 1 calc(50% - 8px)', md: '1 1 auto' } },
            },
          }}
        />
        <DatePicker
          label={endLabel}
          value={endDate}
          onChange={onEndDateChange}
          disabled={disabled}
          minDate={startDate || undefined}
          slotProps={{
            textField: {
              size: 'small',
              sx: { minWidth: 150, flex: { xs: '1 1 calc(50% - 8px)', md: '1 1 auto' } },
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};
